/**
 * @generated SignedSource<<179e2ef722011360d57ec628a72f4a41>>
 * @relayHash 1a1fa6193f4c1b504180b39801d236b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46a4ccbc5551eab017f7cc101b63a1401cc0ac15f18b6f069f3a7dfcc6ce9af4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type formatRulesQuery$variables = {
  cloudId: string;
  first: number;
  projectKey: string;
};
export type formatRulesQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly conditionalFormattingRules: {
        readonly " $fragmentSpreads": FragmentRefs<"formatRuleConnection">;
      } | null | undefined;
    };
  };
};
export type formatRulesQuery = {
  response: formatRulesQuery$data;
  variables: formatRulesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v7 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v8 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v9 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "singleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ],
      "type": "JiraFormattingSingleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "multipleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "values"
        }
      ],
      "type": "JiraFormattingMultipleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "noValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        }
      ],
      "type": "JiraFormattingNoValueOperand"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "formatRulesQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "formatRuleConnection",
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "formattingColor",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/),
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "argumentDefinitions": []
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "formatRulesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "46a4ccbc5551eab017f7cc101b63a1401cc0ac15f18b6f069f3a7dfcc6ce9af4",
    "metadata": {},
    "name": "formatRulesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "74ea1fa8f6a5533fcb3f20473d740504";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
